module.exports = "<input type=\"file\" name=\"file\" [id]=\"componentId\" [ngClass]=\"classComponent\" [placeholder]=\"placeholder\" [disabled]=\"disabled || loading\" [accept]=\"fileType\" (change)=\"onFileChange($event)\">"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/upload-component/upload-component.html
// module id = ./web/modern/components/common/upload-component/upload-component.html
// module chunks = 0